import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, Globe, Receipt, Building2, Wallet, Settings, LogOut, X } from 'lucide-react';
import { useAppContext } from '../../contexts/AppContext';
import { formatCurrency } from '../../utils/formatters';
import { BillvastLogo } from '../ui/BillvastLogo';
type SidebarProps = {
  isOpen: boolean;
  onClose: () => void;
};
export const Sidebar: React.FC<SidebarProps> = ({
  isOpen,
  onClose
}) => {
  const {
    state,
    logout
  } = useAppContext();
  const {
    user
  } = state;
  const navItems = [{
    name: 'Overview',
    path: '/dashboard',
    icon: LayoutDashboard
  }, {
    name: 'Crowdfunding',
    path: '/dashboard/crowdfunding',
    icon: Users
  }, {
    name: 'Diaspora Exchange',
    path: '/dashboard/diaspora',
    icon: Globe
  }, {
    name: 'Bill Payments',
    path: '/dashboard/bills',
    icon: Receipt
  }, {
    name: 'Facility Mgmt',
    path: '/dashboard/facility',
    icon: Building2
  }, {
    name: 'Wallet',
    path: '/dashboard/wallet',
    icon: Wallet
  }, {
    name: 'Settings',
    path: '/dashboard/settings',
    icon: Settings
  }];
  const handleLogout = () => {
    logout();
  };
  return <>
      {/* Mobile Overlay */}
      {isOpen && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={onClose} data-id="element-198" />}

      <aside className={`
        fixed top-0 left-0 z-50 h-screen w-64 bg-white border-r border-gray-100 flex flex-col transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `} data-id="element-199">
        {/* Logo */}
        <div className="h-16 flex items-center justify-between px-6 border-b border-gray-100 shrink-0" data-id="element-200">
          <BillvastLogo size="md" data-id="element-201" />
          <button onClick={onClose} className="lg:hidden text-gray-500 hover:text-gray-700" data-id="element-202">
            <X size={20} data-id="element-203" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1" data-id="element-204">
          {navItems.map(item => <NavLink key={item.name} to={item.path} className={({
          isActive
        }) => `
                flex items-center gap-3 px-3 py-2.5 rounded-xl font-medium transition-colors
                ${isActive ? 'bg-brand-primary/10 text-brand-primary-dark' : 'text-brand-text-light hover:bg-gray-50 hover:text-brand-text-dark'}
              `} data-id="element-205">
              <item.icon size={20} data-id="element-206" />
              {item.name}
            </NavLink>)}
        </nav>

        {/* Bottom Section */}
        <div className="p-4 border-t border-gray-100 shrink-0" data-id="element-207">
          {/* Wallet Balance Mini Card */}
          <div className="bg-brand-primary-dark rounded-xl p-4 mb-4 text-white" data-id="element-208">
            <p className="text-brand-primary-light text-xs font-medium mb-1" data-id="element-209">
              Wallet Balance
            </p>
            <p className="text-lg font-bold" data-id="element-210">
              {formatCurrency(user?.walletBalance || 0)}
            </p>
          </div>

          {/* User Profile & Logout */}
          <div className="flex items-center justify-between" data-id="element-211">
            <div className="flex items-center gap-3" data-id="element-212">
              <img src={user?.avatar} alt={user?.name} className="w-10 h-10 rounded-full border border-gray-200" data-id="element-213" />
              <div className="overflow-hidden" data-id="element-214">
                <p className="text-sm font-semibold text-brand-text-dark truncate" data-id="element-215">
                  {user?.name}
                </p>
                <p className="text-xs text-brand-text-light truncate" data-id="element-216">
                  {user?.email}
                </p>
              </div>
            </div>
            <button onClick={handleLogout} className="p-2 text-gray-400 hover:text-brand-error transition-colors rounded-lg hover:bg-red-50" title="Logout" data-id="element-217">
              <LogOut size={18} data-id="element-218" />
            </button>
          </div>
        </div>
      </aside>
    </>;
};